import React from 'react';
import '../styles/AboutSection.css';

const AboutSection = () => {
  return (
    <section id="about" className="about-section section-padding">
      <div className="container">
        <div className="about-content">
          <div className="about-text">
            <h2 className="heading-1">
              Restoring Trust in <span className="accent-orange">Wellness</span>
            </h2>
            <p className="body-large">
              In a world where food, supplements, and health products are increasingly adulterated and over-processed, Mushhrushh stands as a beacon of purity and transparency.
            </p>
            <p className="body-regular">
              We are dedicated to the cultivation and delivery of premium adaptogenic mushrooms, with our core specialization in Cordyceps militaris. Every stage of our process — from culture to cultivation, harvesting, drying, testing, and packaging — is conducted with complete control and scientific precision.
            </p>
            <p className="body-regular">
              Our philosophy is rooted in holistic wellness, purity, and unwavering trust. We bridge the ancient wisdom of traditional medicine with modern scientific validation, offering you adaptogenic solutions that are 100% organic, vegan, and lab-verified.
            </p>
          </div>
          <div className="about-stats">
            <div className="stat-card">
              <div className="stat-number accent-orange">100%</div>
              <div className="stat-label">Organic & Vegan</div>
            </div>
            <div className="stat-card">
              <div className="stat-number accent-orange">Lab</div>
              <div className="stat-label">Tested & Verified</div>
            </div>
            <div className="stat-card">
              <div className="stat-number accent-orange">Zero</div>
              <div className="stat-label">Adulteration</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;